export const EMPTY_FILTERS = { search: "", assignees: [], priorities: [], groups: [] };

export const PRIORITY_LABELS = { high: "Yüksek", medium: "Orta", low: "Düşük" };

export const activeFilterCount = (f) =>
  (f.search.trim() ? 1 : 0) + f.assignees.length + f.priorities.length + f.groups.length;

export const matchesFilters = (task, f) => {
  const q = f.search.trim().toLowerCase();
  if (q && !(task.title || "").toLowerCase().includes(q)) return false;
  if (f.assignees.length) {
    const keys = (task.assignees || []).map((a) => `${a.type}:${a.id}`);
    const wantsNone = f.assignees.includes("none");
    if (!keys.some((k) => f.assignees.includes(k)) && !(wantsNone && keys.length === 0)) return false;
  }
  if (f.priorities.length && !f.priorities.includes(task.priority || "medium")) return false;
  if (f.groups.length && !f.groups.includes(task.group || "")) return false;
  return true;
};
